/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var _a;
var isWeb = typeof window !== 'undefined' && 'onload' in window;
typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
var isMiniAli = typeof my !== 'undefined' && !!my && (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
var isMiniTt = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
var isMiniWx = !isMiniTt &&
    typeof wx !== 'undefined' &&
    !!wx &&
    (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
var isMini = isMiniAli || isMiniWx || isMiniTt;
typeof WXEnvironment !== 'undefined' &&
    !!WXEnvironment &&
    WXEnvironment.platform !== 'Web';
var aliUA = '';
try {
    aliUA = navigator.userAgent || navigator.swuserAgent || '';
}
catch (error) {
    aliUA = '';
}
var isMiniweb = (isWeb && aliUA.indexOf('Triver') > -1) || aliUA.indexOf('miniProgram') > -1;
var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
(_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
var isWindvane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isNebula = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA || '') &&
    /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isFliggy = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isDingTalk = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA || '');
var isDingTalkPC = /\s+DingTalk\(/i.test(aliUA);
aliUA.indexOf('Android') > -1 || aliUA.indexOf('Adr') > -1;
!!aliUA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

function notSupport(_a) {
    var fail = _a.fail;
    fail({
        errCode: '1',
        errMsg: 'not support',
    });
}
function enhanceSuccess(success, _originalInput, formatOptions, formatErrorOptions) {
    if (success === void 0) { success = function (ret) { return ret; }; }
    if (formatOptions === void 0) { formatOptions = {}; }
    if (formatErrorOptions === void 0) { formatErrorOptions = {}; }
    var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
    return function (ret) {
        var _a;
        if (ret && ret.error) {
            var onFail = enhanceFail(_originalInput && _originalInput.fail, formatErrorOptions);
            return onFail(ret);
        }
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(ret);
        }
        else if (outputMap) {
            (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                output[key] = ret[outputMap[key]];
            });
        }
        output = __assign(__assign({}, ret), output);
        outputMap && delete outputMap.ret;
        outputMap && delete outputMap.status;
        success(__assign(__assign({}, output), { _original: {
                input: _originalInput,
                output: ret,
            } }));
    };
}
function enhanceFail(fail, formatOptions) {
    if (fail === void 0) { fail = function (e) { return e; }; }
    if (formatOptions === void 0) { formatOptions = {}; }
    return function (e) {
        var _a;
        var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(e);
        }
        else if (outputMap) {
            (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                output[key] = e[outputMap[key]];
            });
        }
        output = __assign(__assign({}, e), output);
        outputMap && delete outputMap.ret;
        outputMap && delete outputMap.status;
        return fail(__assign({ _originalErrInfo: e }, output));
    };
}
function apiCall(apiName, params, JSCall, formatOptions, errFormatOptions) {
    var _a;
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    var success = params.success, fail = params.fail;
    var options = {};
    var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
    if (typeof formatInput === 'function') {
        options = formatInput(params);
    }
    else if (inputMap) {
        (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            options[key] = params[inputMap[key]];
        });
    }
    options = __assign(__assign({}, params), options);
    var onSuccess = enhanceSuccess(success, options, {
        outputMap: outputMap,
        formatOutput: formatOutput,
    }, errFormatOptions);
    var onFail = enhanceFail(fail, errFormatOptions);
    apiName
        ? JSCall(apiName, options, onSuccess, onFail)
        : JSCall(__assign(__assign({}, options), { onSuccess: onSuccess, onFail: onFail }));
}
function promisifyApi(apiFn, plugins) {
    var promisify = function (apiFn) { return function (params) {
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            var success = function (e) {
                if (typeof params.success === 'function') {
                    params.success(e);
                }
                else {
                    resolve(e);
                }
            };
            var fail = function (e) {
                typeof params.fail === 'function' && params.fail(e);
                reject(e);
            };
            if (!params.onSuccess) {
                params.onSuccess = success;
            }
            if (!params.onFail) {
                params.onFail = fail;
            }
            apiFn(__assign(__assign({}, params), { success: success, fail: fail }));
        });
    }; };
    var api = promisify(apiFn);
    return api;
}

var ERR_USER_CANCEL = '11';
var ERR_COMMON = '11';
var ERR_MSG_CANCEL = 'cancel';
var ERR_MSG_COMMON = 'call failed';

var JSCall$1 = function (api, options, success, failure) {
    if (success === void 0) { success = function (r) { }; }
    if (failure === void 0) { failure = function (e) { }; }
    if (typeof options === 'function') {
        failure = success;
        success = options;
        options = {};
    }
    if (!__windvane__.call) {
        new Function(__windvane__.windVaneCoreJs())();
    }
    __windvane__.call(api, options, success, failure);
};
function WVCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, JSCall$1, formatOptions, errFormatOptions);
}
function chooseImage$1(params) {
    var formatInput = function (options) {
        var _a, _b;
        var mode = 'both';
        var sourceTypeInlcudeCamera = ((_a = options.sourceType) === null || _a === void 0 ? void 0 : _a.indexOf('camera')) > -1;
        var sourceTypeInlcudePhoto = ((_b = options.sourceType) === null || _b === void 0 ? void 0 : _b.indexOf('album')) > -1;
        if (sourceTypeInlcudeCamera || sourceTypeInlcudePhoto) {
            if (sourceTypeInlcudeCamera) {
                mode = 'camera';
            }
            if (sourceTypeInlcudePhoto) {
                mode = 'photo';
            }
        }
        return {
            type: '0',
            v: '2.0',
            mode: mode,
            mutipleSelection: options.multipleSelection || '0',
            bizCode: 'mtopupload',
            needLogin: false,
            maxSelect: options.count || 1,
        };
    };
    var formatOutput = function (ret) {
        var images = ret.images;
        return params.multipleSelection == '1'
            ? {
                tempFilePaths: images.map(function (image) { return image.localPath; }),
                tempFiles: images.map(function (image) {
                    return {
                        path: image.localPath,
                        previewURL: image.url,
                    };
                }),
            }
            : {
                tempFilePaths: [ret.localPath],
                tempFiles: [
                    {
                        path: ret.localPath,
                        previewURL: ret.url,
                    },
                ],
            };
    };
    var errFormatOutput = function (error) {
        var errorCode = error.status === 'RET_PHOTO_CANCEL' ? ERR_USER_CANCEL : ERR_COMMON;
        var errorMsg = error.msg === 'RET_PHOTO_CANCEL' ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
        return {
            error: errorCode,
            errorMsg: errorMsg,
        };
    };
    return WVCall('WVCamera.takePhoto', params, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    }, { formatOutput: errFormatOutput });
}
function chooseAndUploadImage$3(params) {
    chooseImage$1(__assign(__assign({}, params), { success: function (res) {
            var options = __assign(__assign({}, res), params);
            uploadImage$1(options);
        } }));
}
function uploadImage$1(params) {
    var files = params.tempFiles || params.files;
    if (files && files.length && files[0].path) {
        var urlList_1 = [];
        var originalRes_1 = [];
        files
            .reduce(function (promise, file) {
            return promise.then(function () {
                return new Promise(function (resolve1, reject1) {
                    var options = {
                        path: file.path,
                        v: '2.0',
                        bizCode: params.bizCode || 'mtopupload',
                        needLogin: false,
                    };
                    var onSuccess = function (ret) {
                        urlList_1.push(ret.resourceURL);
                        originalRes_1.push(ret);
                        resolve1();
                    };
                    var onFail = function (e) {
                        reject1(e);
                    };
                    JSCall$1('WVCamera.confirmUploadPhoto', options, onSuccess, onFail);
                });
            });
        }, Promise.resolve())
            .then(function () {
            var success = params.success;
            var onSuccess = enhanceSuccess(success, {});
            onSuccess({
                urlList: urlList_1,
                _original: { output: originalRes_1 },
            });
        })
            .catch(function (error) {
            var onFail = enhanceFail(params.fail);
            return onFail(error);
        });
    }
}

var readyCall = function (fn) {
    if (window.AlipayJSBridge) {
        fn();
    }
    else {
        var _once_1 = function () {
            fn();
            document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
        };
        document.addEventListener('AlipayJSBridgeReady', _once_1, false);
    }
};
var call = function (api, options, success, failure) {
    if (typeof options === 'function') {
        failure = success;
        success = options;
        options = {};
    }
    readyCall(function () {
        AlipayJSBridge.call(api, options, success, failure);
    });
};

function NBCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, call, formatOptions, errFormatOptions);
}
function chooseImage(params) {
    var formatInput = function () {
        return {
            publicDomain: true,
        };
    };
    var formatOutput = function (ret) {
        var formattedData = {
            tempFilePaths: [],
            tempFiles: [],
        };
        var previewURLList = ret.apFilePathsV2 || ret.apFilePaths;
        previewURLList.forEach(function (previewURL, index) {
            if (ret.localIds) {
                formattedData.tempFiles.push({
                    localId: ret.localIds[index],
                    previewURL: previewURL,
                });
                formattedData.tempFilePaths.push(previewURL);
            }
            if (ret.tempFilePaths) {
                var tempFilePaths = ret.tempFilePaths;
                if (typeof tempFilePaths === 'string') {
                    tempFilePaths = JSON.parse(tempFilePaths);
                }
                formattedData.tempFiles.push({
                    path: tempFilePaths[index],
                    previewURL: previewURL,
                });
                formattedData.tempFilePaths.push(tempFilePaths[index]);
            }
        });
        return formattedData;
    };
    NBCall('chooseImage', params, { formatInput: formatInput, formatOutput: formatOutput });
}
function chooseAndUploadImage$2(params) {
    chooseImage(__assign(__assign({}, params), { success: function (res) {
            var options = __assign(__assign({}, res), params);
            uploadImage(options);
        } }));
}
function uploadImage(params) {
    try {
        delete params.ex;
    }
    catch (error) { }
    var promises = [];
    var files = params.tempFiles || params.files;
    files.forEach(function (file) {
        promises.push(new Promise(function (resolve, reject) {
            var options = {
                compress: 4,
                business: params.business || 'NebulaBiz',
                publicDomain: true,
                dataType: '',
                data: '',
            };
            if (file.path) {
                options.dataType = 'fileURL';
                options.data = file.path;
            }
            else if (file.dataURL) {
                options.dataType = 'dataURL';
                options.data = file.dataURL;
            }
            else if (file.localId) {
                options.dataType = 'localID';
                options.data = file.localId;
            }
            else ;
            var onSuccess = function (ret) {
                if (ret.errorMessage) {
                    reject(ret);
                }
                else {
                    resolve(__assign(__assign(__assign({}, ret), ret.result), { _originalOutput: ret, _originalInput: options }));
                }
            };
            var onFail = function (e) { return reject(e); };
            call('uploadImage', options, onSuccess, onFail);
        }));
    });
    var success = params.success, fail = params.fail;
    var onSuccess = typeof success === 'function' ? function (ret) { return success(ret); } : function (ret) { return ret; };
    Promise.all(promises)
        .then(function (results) {
        var res = [];
        var originalRes = [];
        results.forEach(function (item) {
            res.push(item.publicUrl);
            originalRes.push(item);
        });
        onSuccess(__assign(__assign({}, params), { urlList: res, originalRes: originalRes, _originalOutput: originalRes }));
    })
        .catch(function (error) {
        fail(error);
    });
}

var platform = '';
try {
    platform = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
        ? 'iOS'
        : 'Android';
}
catch (error) { }
var JSCall = function () {
    var _a;
    var _b;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof window !== 'undefined' &&
        !!window &&
        typeof ((_b = window === null || window === void 0 ? void 0 : window.FYBridge) === null || _b === void 0 ? void 0 : _b.call) === 'function') {
        return (_a = window.FYBridge).call.apply(_a, __spread(args));
    }
    function genID() {
        return ~~(Math.random() * 1000);
    }
    var cMap = {
        successCallback: 'suc_',
        callbackCommand: 'cmd_',
        failCallback: 'fail_',
    };
    function genCallback(api, type, fn, isKeep) {
        var cname = ("" + (isKeep ? 'e_handler_' : api + "_" + (cMap[type] || 'callback_')) + genID()).replace(/\//gi, '_');
        window[cname] = (function (cb, _cname) {
            return function () {
                var rest = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rest[_i] = arguments[_i];
                }
                cb.apply(void 0, __spread(rest));
                if (!isKeep) {
                    delete window[_cname];
                }
            };
        })(fn, cname);
        return cname;
    }
    var FYBridge = window.FYBridge;
    if (!FYBridge) {
        var pushBack_1 = function (api, params, isKeep) {
            if (params === void 0) { params = {}; }
            var name = 'bridge';
            var action = "bridge://" + api;
            var isAbnormal = /:\/\//.test(api);
            if (isAbnormal) {
                action = api;
                var _arr = api.split('://');
                name = _arr[0];
                api = _arr[1];
            }
            for (var i in params) {
                if (Object.prototype.hasOwnProperty.call(params, i)) {
                    if (typeof params[i] === 'function') {
                        params[i] = genCallback(api, i, params[i], isKeep);
                    }
                    var formattedKey = params.ignore2LowerCase
                        ? i
                        : i.replace(/([A-Z])/g, '_$1').toLowerCase();
                    if (i !== formattedKey) {
                        params[formattedKey] = params[i];
                        delete params[i];
                    }
                }
            }
            if (platform === 'iOS') {
                if (/\bWK\b/i.test(navigator.userAgent)) {
                    params._action_ = api;
                    webkit.messageHandlers[name].postMessage(params);
                }
                else {
                    alitripNativeCall(action, params);
                }
            }
            else {
                __JSContext__.alitripNativeCall(action, JSON.stringify(params));
            }
        };
        var call = function (api, options, success, failure) {
            if (typeof options === 'function') {
                failure = success;
                success = options;
                options = {};
            }
            if (success) {
                options.callbackCommand = options.successCallback = success;
            }
            if (failure) {
                options.failCallback = failure;
            }
            if (options.clickHandler || options.clickCallback) {
                pushBack_1(api, options, true);
            }
            else {
                pushBack_1(api, options);
            }
        };
        FYBridge = { version: '1', call: call };
        Object.defineProperty(window, 'FYBridge', {
            enumerable: true,
            value: FYBridge,
        });
    }
    return FYBridge.call.apply(FYBridge, __spread(args));
};
function LXCall(apiName, params, formatOptions, errFormatOptions) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    apiCall(apiName, params, JSCall, formatOptions, errFormatOptions);
}
function chooseAndUploadImage$1(params) {
    var formatInput = function (options) {
        var camera = (options.sourceType || []).indexOf('camera') > -1;
        var pickType = camera ? 1 : 0;
        return {
            pickType: pickType,
            maxSelect: options.count || 1,
        };
    };
    var outputMap = {
        urlList: 'imgUrls',
    };
    LXCall('take_photo', params, { formatInput: formatInput, outputMap: outputMap });
}

var chooseAndUploadImage$4;
if (isWeb) {
    if (isWindvane) {
        chooseAndUploadImage$4 = chooseAndUploadImage$3;
    }
    else if (isNebula) {
        chooseAndUploadImage$4 = chooseAndUploadImage$2;
    }
    else if (isFliggy) {
        chooseAndUploadImage$4 = chooseAndUploadImage$1;
    }
    else if (isDingTalk) {
        chooseAndUploadImage$4 = notSupport;
    }
    else if (isDingTalkPC) {
        chooseAndUploadImage$4 = notSupport;
    }
}
else if (isMini) {
    if (isMiniAli) {
        chooseAndUploadImage$4 = notSupport;
    }
    else if (isMiniWx) {
        chooseAndUploadImage$4 = notSupport;
    }
    else if (isMiniTt) {
        chooseAndUploadImage$4 = notSupport;
    }
}
else if (isMiniweb) {
    chooseAndUploadImage$4 = notSupport;
}
if (!chooseAndUploadImage$4) {
    chooseAndUploadImage$4 = notSupport;
}
var index = promisifyApi(chooseAndUploadImage$4);

var apiConfig = {};
// 淘宝API：https://h5.alibaba-inc.com/api/WindVane-API.html#WVCamera-takePhoto
// 支付宝API： https://smallfish.antfin-inc.com/jsapi/uploadImage.html
/**
 * 选择相册并上传图片。
 * 注意：
 * 1. windvane容器。涉及到图片存储，要想图片不丢失，需要申请业务bizCode。bizCode不传默认是mtopupload，只用在本地测试，在线上使用出现问题概不负责。bizCode请求地址：https://code.alibaba-inc.com/picturecenter/wikipedia/blob/master/%E6%8E%A5%E5%85%A5%E6%96%87%E6%A1%A3.md
 * 2. 支付宝容器。同样涉及图片存储，使用business字段。默认值是：NebulaBiz。business申请地址：https://yuque.antfin.com/amm/apis/notice
 * 3. 踩坑：支付宝容器，开发环境调用会报“new jsapi permission deny”错误，只需要发布到支付宝支持的http域名白名单即可解决。
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { chooseAndUploadImage } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * chooseAndUploadImage({ bizCode: 'cnocean' })
 *   .then((res) => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var chooseAndUploadImage = extend(apiConfig, index);

export { chooseAndUploadImage };
